// Redacted versions - names cropped out to keep the public site alias-only.
// Unredacted originals stay local-only (see .gitignore) and aren't imported here.
import claude101Cert from '../images/certificate-nrwbvj7shfvp-redacted.jpg';
import aiFluencyCert from '../images/certificate-mpgdmw3na5sn-redacted.jpg';

export type Certification = {
  title: string;
  issuer: string;
  dateEarned?: string;
  imageUrl?: string;
  // Public verification URL for the credential, if available.
  verifyUrl?: string;
};

export const certifications: Certification[] = [
  {
    title: 'Certificate of Completion: Claude 101',
    issuer: 'Anthropic Education',
    dateEarned: 'July 16, 2026',
    imageUrl: claude101Cert,
    verifyUrl: 'https://verify.skilljar.com/c/nrwbvj7shfvp',
  },
  {
    title: 'Certificate of Completion: AI Fluency Framework & Foundations',
    issuer: 'Anthropic Education',
    dateEarned: 'July 17, 2026',
    imageUrl: aiFluencyCert,
    verifyUrl: 'https://verify.skilljar.com/c/mpgdmw3na5sn',
  },
];
